import apiSlice from "./ApiSlice";

const levelApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllLevelData: builder.query({
      providesTags: ["level"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/level",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteLevelById: builder.mutation({
      invalidatesTags: ["level"],
      query: (id: any) => ({
        url: `/level/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addLevel: builder.mutation({
      invalidatesTags: ["level"],
      query: (body) => ({
        url: `/level/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getLevelById: builder.query({
      providesTags: ["level"],
      query: (id: string) => {
        return {
          url: `/level/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateLevelById: builder.mutation({
      invalidatesTags: ["level"],
      query: ({ body, id }) => ({
        url: `/level/${id}`,
        method: "PUT",
        body,
      }),
    }),

    //get AllLevels
    getAllLevels: builder.query({
      providesTags: ["level"],
      query: () => {
        return {
          url: `/level`,
          method: "GET",
        };
      },
    }),

      
    // change status of delivery date
    changeStatusLevelById: builder.mutation({
      invalidatesTags: ["level"],
      query: ({ body, id }) => ({
        url: `/level/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllLevelDataQuery,
  useDeleteLevelByIdMutation,
  useAddLevelMutation,
  useGetLevelByIdQuery,
  useGetAllLevelsQuery,
  useUpdateLevelByIdMutation,
  useChangeStatusLevelByIdMutation,
} = levelApi;
